import axios from "axios";

import {
CAREER_ADD,ADMIN_ERROR_STATE} from "./careerConstant"
import { environmentalURL } from "../environmentalURL";

export const getCareerAdd = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${environmentalURL}/api/careers/apply`,
      formData,
      
    );
    console.log("Career job added successfully:", res.data);
    dispatch({ type: CAREER_ADD, payload: res.data });
  } catch (err) {
    dispatch({ type: ADMIN_ERROR_STATE, payload: err });
  }
};
 